import animateOnScroll from "./animateOnScroll"
import Glide from "@glidejs/glide";

//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".fade-in", offset: 0.25, multiple: true }
]);

const slider = document.querySelector("#NewsGlide");
const activeBullet = "glide__bullet--active";
const bulletsContainerElement = slider.querySelector(".glide__bullets");

const changeActiveBullet = (newIndex, containerElement) => {
  const glideDir = containerElement.querySelector(
    `[data-glide-dir="=${newIndex}"]`
  );

  containerElement
    .querySelector(`.${activeBullet}`)
    .classList.remove(activeBullet);

  if (glideDir) glideDir.classList.add(activeBullet);
};

if (slider) {
  const quoteSlider = new Glide(slider, {
    type: "carousel",
    startAt: 0,
    focusAt: 0,
    gap: 40,
    perView: 3,
    autoplay: false,
    animationDuration: 400,
    peek: 0,
    breakpoints: {
      1200: {
        gap: 20,
      },
      992: {
        perView: 2,
        focusAt: 1,
        gap: 20,
      },
      768: {
        perView: 1
      }
    }
  });
  quoteSlider.mount();
  quoteSlider.on("run", () => {
    requestAnimationFrame(() =>
      changeActiveBullet(quoteSlider.index, bulletsContainerElement)
    );
  });
}